import authenticated from './http-clients/authenticated'

export default {
  getApiVersion () {
    return authenticated({
      url: '/version',
      method: 'get'
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/diagnostics-api.js